export default __webpack_public_path__ + "static/media/magician-card.ca27a4fe.png";